import { Mail, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { CtaButton } from "@/components/landing/shared";

export const Footer = () => (
  <footer className="border-t border-zinc-900 bg-black">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="flex flex-col gap-10 border-b border-zinc-900 pb-12 lg:flex-row lg:items-center lg:justify-between">
        <h3 className="max-w-lg font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl">
          Ready to test a scroll-stopping video ad — for free?
        </h3>
        <CtaButton testid="footer-cta">Submit brief now</CtaButton>
      </div>

      <div className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <a
          href="https://flownavy.com"
          data-testid="footer-logo"
          className="font-display text-xl font-extrabold tracking-tight text-white transition-colors hover:text-[#C7FF3C]"
        >
          FLOWNAVY<span className="text-zinc-500">.</span>
        </a>
        <a
          href="mailto:saurav@flownavy.com"
          data-testid="footer-email"
          className="inline-flex items-center gap-2 ff-mono text-sm text-zinc-400 transition-colors hover:text-white"
        >
          <Mail className="h-4 w-4" />
          saurav@flownavy.com
        </a>
        <a
          href="https://www.instagram.com/flow_navy?igsh=aHpkNXFsanI0bTJi"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="inline-flex items-center gap-2 ff-mono text-sm text-zinc-400 transition-colors hover:text-[#C7FF3C]"
        >
          <Instagram className="h-4 w-4" />
          @flow_navy
        </a>
        <p className="ff-mono text-xs text-zinc-600">
          © {new Date().getFullYear()} Flownavy Motion Studio
        </p>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="ff-mono text-xs text-zinc-500 transition-colors hover:text-[#C7FF3C]"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  </footer>
);
